import script from "./App.vue?vue&type=script&setup=true&name=App&lang=js"
export * from "./App.vue?vue&type=script&setup=true&name=App&lang=js"

import "./App.vue?vue&type=style&index=0&id=74f00801&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f00801"]])

export default __exports__